import { NavLink } from "react-router-dom";

import { IMenuItem, IPathParams } from "@/app/routing/types";
import { useLateInitContext } from "@/shared/hooks/use-late-init-context";

import { AsideContext } from "../../model/navigation-menu/context/context";

interface MenuItemProps {
	menuItem?: IMenuItem;
	route?: string;
	pathParams?: IPathParams;
}

export const MenuLabel = ({ route, menuItem, pathParams }: MenuItemProps) => {
	const { afterClick } = useLateInitContext(AsideContext);

	if (!menuItem) return null;

	const { title, to } = menuItem;

	if (!route) return title || null;

	const path = to ? to(pathParams || {}) : `/${route}`;

	const onNavLinkClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		afterClick?.();
	};

	return (
		<NavLink data-testid="link" to={path} onClick={onNavLinkClick}>
			{title}
		</NavLink>
	);
};
